import { render } from "./VerifyEmailView.vue?vue&type=template&id=5afbc780&scoped=true"
import script from "./VerifyEmailView.vue?vue&type=script&lang=js"
export * from "./VerifyEmailView.vue?vue&type=script&lang=js"

import "./VerifyEmailView.vue?vue&type=style&index=0&id=5afbc780&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afbc780"]])

export default __exports__